import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { axiosInstance } from '../../lib/axiosInstance';
import { useNavigate } from 'react-router-dom';



function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token and email from query params
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');            //For video call --> extract sessionID like this for Video call.
  const email = queryParams.get('email');
  const tokenAndEmail = {
      token: token,
      email: email
  }

  useEffect(() => {
    if (token && email) {
      // Call the backend to verify the email
      axiosInstance.post('/auth/verify-email', tokenAndEmail)  //For video call --> post the sessionID similarly to the video call post route.
        .then(response => {
          console.log('Email verified successfully:', response.data);
          navigate('/signin');                      //For video call --> navigate('/video_call_page?sessionID=${sessID}');
          // Redirect or show success message
        })
        .catch(error => {
          console.error('Email verification failed:', error);
          // Handle error, show message to user
        });
    }
  }, [token, email]);

  return (
    <div>
      <h2>Verifying your email...</h2>            {/*For video call --> <h2>Setting up the session...</h2> */}
      {/* You can add some loading state or message */}
    </div>
  );
}

export default VerifyEmail;
